import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";

import { ProductInfoExpanded_StoreProduct$key } from "./__generated__/ProductInfoExpanded_StoreProduct.graphql";
import { ScrollView } from "react-native";
import { ProductDetailsComponent } from "./ProductDetails";
import { ProductHeader } from "./ProductHeader";

export function ProductInfoExpanded(props: {
  product: ProductInfoExpanded_StoreProduct$key;
}) {
  const product = useFragment(
    graphql`
      fragment ProductInfoExpanded_StoreProduct on StoreProduct {
        id
        ...ProductHeader_ProductDetails
        ...ProductDetailsComponent_ProductDetails
      }
    `,
    props.product
  );

  return (
    <ScrollView>
      <ProductHeader product={product} />
      <ProductDetailsComponent product={product} />
    </ScrollView>
  );
}
